import { orderBy } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  info: {},
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.GET_SITES:
      return {
        ...state,
        info: {
          ...payload.data,
          Data: orderBy(payload.data.Data, [(x) => x.Id]),
        },
      };

    case types.GET_SITES_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.SITES_LOAD:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/sites/reducer.js